<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
      @btnClick='handleClick'
    >
      <div slot="info">
        <h4>
          <span>退货单号:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="formInfo">
        <div class="cardContainer">
          <lk-card title="退货单信息">
            <lk-form :label-width="140" label-position="right">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="供应商名称:">
                    <span>{{formModel.supplierName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="总金额:">
                    <span>{{formModel.amount}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="24">
                  <lk-form-item label="退回商品:">
                    <div>
                      <lk-table border :columns="columns" :data="tableData"></lk-table>
                    </div>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="退货原因:">
                    <span>{{formModel.remark}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
    <lk-modal v-model="showLog" title="操作日志" footer-hide>
      <div class="records">
        <div class="record" v-for="(item,index) in recordlist" :key='index'  >
          {{item}}
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import CommonFrame from '../commonFrame.vue';

export default {
  components: {
    CommonFrame,
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  data() {
    return {
      showLog: false,
      logData: [],
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '供应商退货审批',
        },
      ],
      btns: [
        // {
        //   name: 'log',
        //   text: '操作日志',
        //   type: 'default',
        // },
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      id: '',
      formModel: {},
      tableData: [],
      columns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '入库时间', key: 'purchaseTime', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品名称', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '有效期', key: 'expiryDate', minWidth: 116 },
        { title: '包装单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '原验收数量', key: 'inspectionPassNum', minWidth: 116 },
        { title: '库存数量', key: 'inventoryTotalNum', minWidth: 116 },
        { title: '退货数量', key: 'num', minWidth: 116 },
        { title: '单价', key: 'refundPrice', minWidth: 116 },
        { title: '退货金额', key: 'amount', minWidth: 116 },
      ],
    };
  },
  computed: {
    recordlist() {
      const result = [];
      this.logData.forEach((el, index) => {
        let str = `${index + 1}.${el.time}, 由 ${el.name}${el.content} 。`;
        if (el.newValue && el.oldValue) {
          str += `修改了，旧值：${el.oldValue}，新值：${el.newValue}.`;
        }
        result.push(str);
      });
      return result;
    },
  },
  methods: {
    handleClick(text) {
      console.log(text);
      if (text === 'log') {
        this.getRecord();
        this.showLog = true;
      }
    },
    // 获取退货单信息
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const data = res.data.data;
        this.tableData = data.purchaseRefundDetailList;
        data.purchaseRefundDetailList.forEach((item) => {
          item.expiryDate = utils.exchangeTime(item.expiryDate);
          item.purchaseTime = utils.exchangeTime(item.purchaseTime);
        });
        this.formModel.supplierName = data.purchaseRefund.supplierName;
        this.formModel.remark = data.purchaseRefund.remark || '无';
        this.formModel.amount = data.purchaseRefund.amount;
        this.id = data.purchaseRefund.code;
        this.infosArr.push({ name: '门店名称', value: data.purchaseRefund.storeName },
          { name: '创建时间', value: utils.exchangeTimeToSecond(data.purchaseRefund.createTime) },
          { name: '创建人', value: data.purchaseRefund.createUserName });
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 后续增加操作日志  暂时保留
    getRecord() {
      // goodsService.getRecord({ businessId: this.goodsStore.id }).then((res) => {
      //   if (res.data.status === 200) {
      //     // this.record
      //     this.logData = [];
      //
      //     res.data.data.forEach((item) => {
      //       const format = {
      //         content: item.content,
      //         newValue: item.newValue,
      //         oldValue: item.oldValue,
      //         time: utils.exchangeTimeToSecond(item.time),
      //         Id: item.userId,
      //         name: item.userName,
      //       };
      //       this.logData.push(format);
      //     });
      //   } else {
      //     this.$Message.error(res.data.error);
      //   }
      // }).catch((err) => {
      //   utils.handleError(err);
      // });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getInfo(this.approvalParams.businessUrl);
  },
};
</script>

<style scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .record{
    font-size: 14px;
    padding: 0 10px;
    line-height: 2
  }
  .records{
    max-height: 60vh;
    overflow: auto
  }
  .padding-span{
    padding-right:15px;
  }
</style>
